module.exports = __webpack_public_path__ + "img/MGH-Nakasu-16.77f9b7f2.jpg";